function Base() {}

Base.prototype.init = function() {};
Base.prototype.afterInit = function() {};
Base.prototype.destroy = function() {};

module.exports = Base;
